const PdfFile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#clip0_91_625)">
      <path
        fill="#2180e2"
        d="M0 2C0 .897.897 0 2 0h5v4c0 .553.447 1 1 1h4v4.5H5.5c-1.103 0-2 .897-2 2V16H2c-1.103 0-2-.897-2-2zm12 2H8V0zm-6.5 7h1a1.751 1.751 0 0 1 0 3.5H6v1c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5v-4c0-.275.225-.5.5-.5m1 2.5c.416 0 .75-.334.75-.75A.75.75 0 0 0 6.5 12H6v1.5zm3-2.5h1a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 1-.5-.5v-4c0-.275.225-.5.5-.5m1 4c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5H10v3zm2.5-3.5c0-.275.225-.5.5-.5H15c.275 0 .5.225.5.5s-.225.5-.5.5h-1v1h1c.275 0 .5.225.5.5s-.225.5-.5.5h-1v1.5c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5v-4"
      />
    </g>
    <defs>
      <clipPath id="clip0_91_625">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default PdfFile;
